import { render, staticRenderFns } from "./mortgage-estimate-received.vue?vue&type=template&id=22710d3b"
import script from "./mortgage-estimate-received.vue?vue&type=script&lang=js"
export * from "./mortgage-estimate-received.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports